import { useState } from 'react';
import { Bar, Checkbox, Columns, FoldPanel, Specimens, Switch } from '@src/components';

export function CheckboxSection() {
  const [remind, setRemind] = useState(true);
  const [surprise, setSurprise] = useState(false);
  const [rules, setRules] = useState(false);
  const [wrapped, setWrapped] = useState(true);
  const [mutual, setMutual] = useState(true);

  return (
    <FoldPanel
      id="checkboxes"
      title="Checkboxes"
      hint="A real input under a drawn box, so focus, tabbing and form submission are the browser's job. States from the Figma, palette from our tokens."
      example={`<Checkbox
  label="Remind me before the draw"
  checked={remind}
  onCheckedChange={setRemind}
  hint="One email, the day before."
/>`}
    >
      <Specimens
        label="States"
        note="Tick them, tab to them — hover deepens the fill, focus adds the same glow as a field."
      >
        <Columns columns="fill" gap={5}>
          <Checkbox
            label="Remind me before the draw"
            checked={remind}
            onCheckedChange={setRemind}
            hint="One email, the day before."
          />
          <Checkbox
            label="Keep my gift a surprise"
            checked={surprise}
            onCheckedChange={setSurprise}
          />
          <Checkbox
            label="I accept the house rules"
            checked={rules}
            onCheckedChange={setRules}
            error="Required before the game starts."
          />
          <Checkbox
            label="Locked while the game is archived"
            checked={wrapped}
            onCheckedChange={setWrapped}
            disabled
            hint="Archived games are read-only."
          />
        </Columns>
      </Specimens>

      <Specimens
        label="Without a label"
        note="For a row selector, where the column heading is the name. Needs an aria-label."
      >
        <Checkbox
          checked={surprise}
          onCheckedChange={setSurprise}
          aria-label="Select this participant"
        />
      </Specimens>

      <Specimens
        label="Sharing a row"
        note="fit sizes the checkbox to its label, so a trailing control keeps the same line instead of dropping below."
      >
        <Bar align="center" gap={4} wide>
          <Checkbox fit label="Никита" checked={surprise} onCheckedChange={setSurprise} />
          <Switch label="Mutual" checked={mutual} onCheckedChange={setMutual} />
        </Bar>
      </Specimens>

      <Specimens
        label="Long label"
        note="The box stays level with the first line rather than the middle of the block."
      >
        <Columns columns="fill" gap={5}>
          <Checkbox
            label="Let the organiser reassign my recipient if somebody drops out before the exchange, even after the draw has happened"
            checked={wrapped}
            onCheckedChange={setWrapped}
          />
        </Columns>
      </Specimens>
    </FoldPanel>
  );
}
